import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import acceptLead from '../actions/AcceptLead';
import finishAcceptLead from '../actions/FinishAcceptLead';
import Loader from './loader';
import pick from '../tools/pick';
import { history } from '../store'

import { ACCEPTING, ACCEPT_FAILED } from '../reducers/accepting-lead';

const AcceptLeadModal = ({ lead }) => {
    const dispatch = useDispatch();
    const { state, error } = useSelector(state => state.acceptingLead);

    const acceptLeadFromEvent = () => {
        dispatch(acceptLead(lead));
        history.push(`/leads/${lead.id}`);
        dispatch(finishAcceptLead());
    };

    let action;
    let message;

    switch (state) {
        case ACCEPTING:
            action = <Loader additionalContainerClass="slim" />;
            break;
        case ACCEPT_FAILED:
            message = pick(
                error,
                ['response', 'data', 'error'],
                'Could not accept the lead',
            );
            action = <p>{message}</p>;
            break;
        default:
            action = (
                <div className="p-20">
                    <button
                        className="btn btn-primary btn-lg text-center ma"
                        onClick={acceptLeadFromEvent}
                        disabled={state === ACCEPTING}
                    >
                        Accept Lead
                    </button>
                </div>
            );
    }

    return (
        <div>
            <h2>Would you like to receive this lead?</h2>
            <p className="lead">{lead.headline}</p>

            <p>
                This lead will be priced at{' '}
                <a href="/pricing" target="_blank" rel="noopener noreferrer">
                    your standard per lead rate
                </a>.
            </p>
            {action}
        </div>
    );
};

AcceptLeadModal.propTypes = {
    lead: PropTypes.object.isRequired,
};

export default AcceptLeadModal;
